const zone = "Europe/Brussels";
const time = new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", hourCycle: "h23", timeZone: zone });
const date = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: zone });

const parse = (iso: string): Date | null => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const formatTime = (iso: string) => {
  const d = parse(iso);
  return d ? time.format(d) : "unknown time";
};
export const formatDate = (iso: string) => {
  const d = parse(iso);
  return d ? date.format(d) : "unknown date";
};
export const formatDateTime = (iso: string) => {
  const d = parse(iso);
  return d ? `${date.format(d)}, ${time.format(d)}` : "unknown time";
};

const ago = (n: number, unit: string) => `${n} ${unit}${n === 1 ? "" : "s"} ago`;

/** "just now", "4 minutes ago", "2 hours ago", "3 days ago". */
export const relativeTime = (iso: string, now: Date = new Date()): string => {
  const d = parse(iso);
  if (!d) return "at an unknown time";
  const minutes = Math.floor((now.getTime() - d.getTime()) / 60_000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return ago(minutes, "minute");
  if (minutes < 24 * 60) return ago(Math.floor(minutes / 60), "hour");
  return ago(Math.floor(minutes / (24 * 60)), "day");
};

/** A calendar date from the server (`YYYY-MM-DD`, a warranty date) as "1 Mar 2027". Empty for none. */
export const formatDay = (day: string | null): string => {
  if (!day || !/^\d{4}-\d{2}-\d{2}$/.test(day)) return "";
  const d = parse(`${day}T12:00:00Z`); // noon UTC is the same day in Brussels
  return d ? date.format(d) : "";
};
